var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocationDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLocationDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter-Change-location",
    transform: "translate(-503.000000, -320.000000)",
    fill: "#646464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Box-Premium-filter-Copy-6",
    transform: "translate(503.000000, 317.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Box-Premium-filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location-Arrow",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7937699,1.09958732 C17.2804676,0.125236612 16.8748862,-0.280742847 15.9014909,0.206432504 L0.732747561,7.7982484 C-0.240647733,8.28542375 -0.28120587,9.15827958 0.834142905,9.32067137 L4.78856129,9.72665083 C6.28921237,9.88904261 7.16121232,10.7010015 7.3031658,12.2437235 L7.70874717,16.2020232 C7.83042158,17.2169719 8.74297967,17.2778688 9.22967732,16.3035181 L16.7937699,1.09958732 Z",
    id: "icLocationDesktop"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationDesktop);
export default __webpack_public_path__ + "static/media/icLocationDesktop.d2279a6267f1fc0d9aa1b0554bd81377.svg";
export { ForwardRef as ReactComponent };